import React, {
    useState,
    useEffect,
    Fragment,
    useContext,
    startTransition,
    useRef
  } from "react";
  
import { useLocation, useParams } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import ReactPlayer from "react-player";
import LiveMatchTrackerSoccer from "./Score/Soccer.js/ScoreBoardSoccer";
import LiveMatchTrackerCricket from "./Score/Cricket/ScoerBoardDetail";
import LiveMatchTrackerTennis from "./Score/Tennis/ScoreBoard";

  const Score = () => {
    const [streamingUrl, setStreamingUrl] = useState("");
    const [mute, setMute] = useState(true);
    const params = useParams();
    const location = useLocation();
    var scoreId = params.scoreId;
    let { user } = useContext(AuthContext);
 const iframeRef = useRef(null);


  const handleIframeLoad = () => {
    const handleMessage = (event) => {
      // security check
      if (event.origin !== "https://scorecard.oddstrad.com") return;

      const data = event.data;
      console.log("data", data);

      // resize event
      if (data.height && iframeRef.current) {
        iframeRef.current.style.height = data.height + "px";
      }

      // custom click event
      if (data.type === "FOOTER_CLICKED") {
        console.log("Footer clicked inside iframe", data);
      }
    };

    window.addEventListener("message", handleMessage);
  };
   
  let tabPosition = {
    4: "bottom",
    2: "top",
    1: "bottom",
  };
  const displayScore = (scoreId,eventType) => {

    return params.eventId && params.eventId.toString().startsWith("-1") ? (
      <iframe
      ref={iframeRef}
      id="scoreFrame"
      scrolling="no"
      sandbox="allow-scripts allow-same-origin"
      referrerPolicy="strict-origin-when-cross-origin"
      className="responsive-iframe w-100"
      style={{
        overflow: "hidden",
       
        backgroundColor: "#000",
        zIndex: 99
      }}
      onLoad={handleIframeLoad}
      src={`https://scorecard.oddstrad.com/get-scorecard-iframe/${params.eventType}/${params.eventId}/${scoreId}`}
    />
    ) : (
      <iframe
        className="responsive-iframe w-100"
        style={{
          overflow: "hidden",
          height:"600px",
          backgroundColor: "#000000",
          width: "100%",
        }}
        id="scoreId"
        src={`https://lmt.route2222.com/#/lmt/${scoreId}`}
      />
    );
  };
   
  
    return (
      <div>
       {  displayScore(params.scoreId,params?.eventType)}
      </div>
    );
  };
  
  export default Score;
  